<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Usuário
          </div>
        </v-toolbar>
        <div class="container dialog">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="8">
                <v-text-field
                  :value="computedNome"
                  label="Nome Do Usuário*"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="$formatCpf(content.cpf)"
                  label="CPF*"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="content.email"
                  label="E-mail*"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="small">Perfis</span>
                <v-chip-group active-class="primary--text">
                  <v-chip v-for="perfil in content.perfis" :key="perfil.id">
                    {{ perfil.nome }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <div class="btn-group text-center mt-7">
              <v-btn color="primary"  @click="$emit('onClose')">
                Fechar
              </v-btn>
            </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Usuario } from '~/commons/classes/usuario';

export default {
  props: new DialogProps(Usuario),
  computed: {
    computedNome(){
      return this.content.nomeSocial ?? this.content.nomeCompleto;
    }
  }
};
</script>

<style scoped>
.chip {
  padding-right: 0.5em;
}
</style>
